import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A string used to identify an i18n locale */
  I18NLocaleCode: { input: any; output: any; }
  InfoPageContentDynamicZoneInput: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  MediaPageContentDynamicZoneInput: { input: any; output: any; }
  MediaPageGalleryDynamicZoneInput: { input: any; output: any; }
  NewsPageContentDynamicZoneInput: { input: any; output: any; }
  ServiceInnPageBottomContentDynamicZoneInput: { input: any; output: any; }
  ServiceInnPageContentDynamicZoneInput: { input: any; output: any; }
  ServiceInvoicePageBottomContentDynamicZoneInput: { input: any; output: any; }
  ServiceInvoicePageContentDynamicZoneInput: { input: any; output: any; }
  ServicePaymentPageBottomContentDynamicZoneInput: { input: any; output: any; }
  ServicePaymentPageContentDynamicZoneInput: { input: any; output: any; }
  ServiceStatusPageBottomContentDynamicZoneInput: { input: any; output: any; }
  ServiceStatusPageContentDynamicZoneInput: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentAccordionAccordionItem = {
  __typename?: 'ComponentAccordionAccordionItem';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentAccordionAccordionItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentAccordionAccordionItemFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentAccordionAccordionItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentAccordionAccordionItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentAccordionAccordionItemInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentContentAccordion = {
  __typename?: 'ComponentContentAccordion';
  id: Scalars['ID']['output'];
  items: Array<Maybe<ComponentAccordionAccordionItem>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentAccordionItemsArgs = {
  filters?: InputMaybe<ComponentAccordionAccordionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentAdvantageItem = {
  __typename?: 'ComponentContentAdvantageItem';
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type ComponentContentAdvantageItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContentAdvantageItemFiltersInput>>>;
  not?: InputMaybe<ComponentContentAdvantageItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContentAdvantageItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentContentAdvantages = {
  __typename?: 'ComponentContentAdvantages';
  advantages: Array<Maybe<ComponentContentAdvantageItem>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentAdvantagesAdvantagesArgs = {
  filters?: InputMaybe<ComponentContentAdvantageItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentImportantInfo = {
  __typename?: 'ComponentContentImportantInfo';
  banner: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentContentLinks = {
  __typename?: 'ComponentContentLinks';
  groups: Array<Maybe<ComponentNavigationGroupLinks>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentLinksGroupsArgs = {
  filters?: InputMaybe<ComponentNavigationGroupLinksFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentMap = {
  __typename?: 'ComponentContentMap';
  coordinates: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<ComponentNavigationMenuItem>;
  title?: Maybe<Scalars['String']['output']>;
  zoom?: Maybe<Scalars['Int']['output']>;
};

export type ComponentContentMarkdown = {
  __typename?: 'ComponentContentMarkdown';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentContentOnSurface = {
  __typename?: 'ComponentContentOnSurface';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentContentStepContent = {
  __typename?: 'ComponentContentStepContent';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentContentStepContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContentStepContentFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentContentStepContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContentStepContentFiltersInput>>>;
};

export type ComponentContentStepItem = {
  __typename?: 'ComponentContentStepItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  steps?: Maybe<Array<Maybe<ComponentContentStepContent>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentStepItemStepsArgs = {
  filters?: InputMaybe<ComponentContentStepContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentContentStepItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentContentStepItemFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentContentStepItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentContentStepItemFiltersInput>>>;
  steps?: InputMaybe<ComponentContentStepContentFiltersInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentContentSteps = {
  __typename?: 'ComponentContentSteps';
  id: Scalars['ID']['output'];
  stepItems?: Maybe<Array<Maybe<ComponentContentStepItem>>>;
  title?: Maybe<Scalars['String']['output']>;
};


export type ComponentContentStepsStepItemsArgs = {
  filters?: InputMaybe<ComponentContentStepItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentFeedbackFeedbackForm = {
  __typename?: 'ComponentFeedbackFeedbackForm';
  active: Scalars['Boolean']['output'];
  consentPDAPage?: Maybe<DocumentPageEntityResponse>;
  emailRecipient: Scalars['String']['output'];
  emailRequired: Scalars['Boolean']['output'];
  feedbackDocTypeRequired: Scalars['Boolean']['output'];
  feedbackDocTypes?: Maybe<FeedbackDocumentTypeRelationResponseCollection>;
  feedbackTopicRequired: Scalars['Boolean']['output'];
  feedbackTopics?: Maybe<FeedbackTopicRelationResponseCollection>;
  id: Scalars['ID']['output'];
  nameRequired: Scalars['Boolean']['output'];
  patronymicRequired: Scalars['Boolean']['output'];
  phoneRequired: Scalars['Boolean']['output'];
  surnameRequired: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  titleActive: Scalars['Boolean']['output'];
};


export type ComponentFeedbackFeedbackFormFeedbackDocTypesArgs = {
  filters?: InputMaybe<FeedbackDocumentTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ComponentFeedbackFeedbackFormFeedbackTopicsArgs = {
  filters?: InputMaybe<FeedbackTopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentFeedbackFeedbackFormInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  consentPDAPage?: InputMaybe<Scalars['ID']['input']>;
  emailRecipient?: InputMaybe<Scalars['String']['input']>;
  emailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  feedbackDocTypeRequired?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackDocTypes?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  feedbackTopicRequired?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackTopics?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  patronymicRequired?: InputMaybe<Scalars['Boolean']['input']>;
  phoneRequired?: InputMaybe<Scalars['Boolean']['input']>;
  surnameRequired?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentLayoutMenuCategory = {
  __typename?: 'ComponentLayoutMenuCategory';
  id: Scalars['ID']['output'];
  menuItems: Array<Maybe<ComponentNavigationMenuItem>>;
  title: Scalars['String']['output'];
};


export type ComponentLayoutMenuCategoryMenuItemsArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentLayoutMenuCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLayoutMenuCategoryFiltersInput>>>;
  menuItems?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  not?: InputMaybe<ComponentLayoutMenuCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLayoutMenuCategoryFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentLayoutMenuCategoryInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  menuItems?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLayoutSearchQueries = {
  __typename?: 'ComponentLayoutSearchQueries';
  id: Scalars['ID']['output'];
  query: Scalars['String']['output'];
};

export type ComponentLayoutSearchQueriesFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLayoutSearchQueriesFiltersInput>>>;
  not?: InputMaybe<ComponentLayoutSearchQueriesFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLayoutSearchQueriesFiltersInput>>>;
  query?: InputMaybe<StringFilterInput>;
};

export type ComponentLayoutSearchQueriesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentLayoutSocialNetwork = {
  __typename?: 'ComponentLayoutSocialNetwork';
  icon: UploadFileEntityResponse;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ComponentLayoutSocialNetworkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentLayoutSocialNetworkFiltersInput>>>;
  not?: InputMaybe<ComponentLayoutSocialNetworkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentLayoutSocialNetworkFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentLayoutSocialNetworkInput = {
  icon?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMainBanner = {
  __typename?: 'ComponentMainBanner';
  id: Scalars['ID']['output'];
  link?: Maybe<ComponentNavigationLink>;
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentMainBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentMainBannerFiltersInput>>>;
  link?: InputMaybe<ComponentNavigationLinkFiltersInput>;
  not?: InputMaybe<ComponentMainBannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentMainBannerFiltersInput>>>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentMainBannerInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentNavigationLinkInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMainMainServices = {
  __typename?: 'ComponentMainMainServices';
  allServicesLink?: Maybe<ComponentNavigationMenuItem>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  menu: Array<Maybe<ComponentNavigationMenuItemWithIcon>>;
  title: Scalars['String']['output'];
};


export type ComponentMainMainServicesMenuArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemWithIconFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentMainMainServicesInput = {
  allServicesLink?: InputMaybe<ComponentNavigationMenuItemInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  menu?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemWithIconInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentMediaImage = {
  __typename?: 'ComponentMediaImage';
  id: Scalars['ID']['output'];
  media: UploadFileEntityResponse;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentMediaRutube = {
  __typename?: 'ComponentMediaRutube';
  id: Scalars['ID']['output'];
  preview: UploadFileEntityResponse;
  title?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['String']['output'];
};

export type ComponentMediaSelfHostedVideo = {
  __typename?: 'ComponentMediaSelfHostedVideo';
  id: Scalars['ID']['output'];
  preview?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  video: UploadFileEntityResponse;
};

export type ComponentNavigationDocument = {
  __typename?: 'ComponentNavigationDocument';
  id: Scalars['ID']['output'];
  media: UploadFileEntityResponse;
  title: Scalars['String']['output'];
};

export type ComponentNavigationDocumentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationDocumentFiltersInput>>>;
  not?: InputMaybe<ComponentNavigationDocumentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationDocumentFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNavigationGroupLinks = {
  __typename?: 'ComponentNavigationGroupLinks';
  groupTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  links: Array<Maybe<ComponentNavigationMenuItemWithAsset>>;
};


export type ComponentNavigationGroupLinksLinksArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNavigationGroupLinksFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationGroupLinksFiltersInput>>>;
  groupTitle?: InputMaybe<StringFilterInput>;
  links?: InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>;
  not?: InputMaybe<ComponentNavigationGroupLinksFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationGroupLinksFiltersInput>>>;
};

export type ComponentNavigationLink = {
  __typename?: 'ComponentNavigationLink';
  id: Scalars['ID']['output'];
  type: LinkType;
  uri: Scalars['String']['output'];
};

export type ComponentNavigationLinkFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationLinkFiltersInput>>>;
  not?: InputMaybe<ComponentNavigationLinkFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationLinkFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  uri?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationLinkInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<LinkType>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNavigationMenuItem = {
  __typename?: 'ComponentNavigationMenuItem';
  id: Scalars['ID']['output'];
  link: ComponentNavigationLink;
  title: Scalars['String']['output'];
};

export type ComponentNavigationMenuItemFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemFiltersInput>>>;
  link?: InputMaybe<ComponentNavigationLinkFiltersInput>;
  not?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationMenuItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentNavigationLinkInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNavigationMenuItemWithAsset = {
  __typename?: 'ComponentNavigationMenuItemWithAsset';
  asset?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  link?: Maybe<ComponentNavigationLink>;
  title: Scalars['String']['output'];
};

export type ComponentNavigationMenuItemWithAssetFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>>>;
  link?: InputMaybe<ComponentNavigationLinkFiltersInput>;
  not?: InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationMenuItemWithAssetInput = {
  asset?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentNavigationLinkInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNavigationMenuItemWithIcon = {
  __typename?: 'ComponentNavigationMenuItemWithIcon';
  icon?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  link: ComponentNavigationLink;
  title: Scalars['String']['output'];
};

export type ComponentNavigationMenuItemWithIconFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemWithIconFiltersInput>>>;
  link?: InputMaybe<ComponentNavigationLinkFiltersInput>;
  not?: InputMaybe<ComponentNavigationMenuItemWithIconFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemWithIconFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentNavigationMenuItemWithIconInput = {
  icon?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<ComponentNavigationLinkInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNewsAsideNews = {
  __typename?: 'ComponentNewsAsideNews';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

export type ComponentNewsAsideNewsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNewsAsideNewsFiltersInput>>>;
  not?: InputMaybe<ComponentNewsAsideNewsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNewsAsideNewsFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
};

export type ComponentNewsAsideNewsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type ContactPage = {
  __typename?: 'ContactPage';
  address: Scalars['String']['output'];
  addressLabel: Scalars['String']['output'];
  button?: Maybe<ComponentNavigationMenuItem>;
  coordinates: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ContactPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  phoneLabel: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workingHours: Scalars['String']['output'];
  workingHoursLabel: Scalars['String']['output'];
  zoom?: Maybe<Scalars['Int']['output']>;
};


export type ContactPageLocalizationsArgs = {
  filters?: InputMaybe<ContactPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContactPageEntity = {
  __typename?: 'ContactPageEntity';
  attributes?: Maybe<ContactPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ContactPageEntityResponse = {
  __typename?: 'ContactPageEntityResponse';
  data?: Maybe<ContactPageEntity>;
};

export type ContactPageEntityResponseCollection = {
  __typename?: 'ContactPageEntityResponseCollection';
  data: Array<ContactPageEntity>;
  meta: ResponseCollectionMeta;
};

export type ContactPageFiltersInput = {
  address?: InputMaybe<StringFilterInput>;
  addressLabel?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ContactPageFiltersInput>>>;
  button?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  coordinates?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ContactPageFiltersInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ContactPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ContactPageFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  phoneLabel?: InputMaybe<StringFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workingHours?: InputMaybe<StringFilterInput>;
  workingHoursLabel?: InputMaybe<StringFilterInput>;
  zoom?: InputMaybe<IntFilterInput>;
};

export type ContactPageInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  button?: InputMaybe<ComponentNavigationMenuItemInput>;
  coordinates?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneLabel?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  workingHours?: InputMaybe<Scalars['String']['input']>;
  workingHoursLabel?: InputMaybe<Scalars['String']['input']>;
  zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type ContactPageRelationResponseCollection = {
  __typename?: 'ContactPageRelationResponseCollection';
  data: Array<ContactPageEntity>;
};

export type DateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  contains?: InputMaybe<Scalars['Date']['input']>;
  containsi?: InputMaybe<Scalars['Date']['input']>;
  endsWith?: InputMaybe<Scalars['Date']['input']>;
  eq?: InputMaybe<Scalars['Date']['input']>;
  eqi?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nei?: InputMaybe<Scalars['Date']['input']>;
  not?: InputMaybe<DateFilterInput>;
  notContains?: InputMaybe<Scalars['Date']['input']>;
  notContainsi?: InputMaybe<Scalars['Date']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  startsWith?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DocumentPage = {
  __typename?: 'DocumentPage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<DocumentPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type DocumentPageLocalizationsArgs = {
  filters?: InputMaybe<DocumentPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DocumentPageEntity = {
  __typename?: 'DocumentPageEntity';
  attributes?: Maybe<DocumentPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type DocumentPageEntityResponse = {
  __typename?: 'DocumentPageEntityResponse';
  data?: Maybe<DocumentPageEntity>;
};

export type DocumentPageEntityResponseCollection = {
  __typename?: 'DocumentPageEntityResponseCollection';
  data: Array<DocumentPageEntity>;
  meta: ResponseCollectionMeta;
};

export type DocumentPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<DocumentPageFiltersInput>>>;
  content?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<DocumentPageFiltersInput>;
  not?: InputMaybe<DocumentPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<DocumentPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type DocumentPageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentPageRelationResponseCollection = {
  __typename?: 'DocumentPageRelationResponseCollection';
  data: Array<DocumentPageEntity>;
};

export enum Enum_Holidaybanner_Type {
  Link = 'link',
  Text = 'text'
}

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FeedbackDocumentType = {
  __typename?: 'FeedbackDocumentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  hint?: Maybe<Scalars['String']['output']>;
  hintPicture?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<FeedbackDocumentTypeRelationResponseCollection>;
  numberRequired: Scalars['Boolean']['output'];
  seriesRequired: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FeedbackDocumentTypeLocalizationsArgs = {
  filters?: InputMaybe<FeedbackDocumentTypeFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeedbackDocumentTypeEntity = {
  __typename?: 'FeedbackDocumentTypeEntity';
  attributes?: Maybe<FeedbackDocumentType>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FeedbackDocumentTypeEntityResponse = {
  __typename?: 'FeedbackDocumentTypeEntityResponse';
  data?: Maybe<FeedbackDocumentTypeEntity>;
};

export type FeedbackDocumentTypeEntityResponseCollection = {
  __typename?: 'FeedbackDocumentTypeEntityResponseCollection';
  data: Array<FeedbackDocumentTypeEntity>;
  meta: ResponseCollectionMeta;
};

export type FeedbackDocumentTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeedbackDocumentTypeFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  hint?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<FeedbackDocumentTypeFiltersInput>;
  not?: InputMaybe<FeedbackDocumentTypeFiltersInput>;
  numberRequired?: InputMaybe<BooleanFilterInput>;
  or?: InputMaybe<Array<InputMaybe<FeedbackDocumentTypeFiltersInput>>>;
  seriesRequired?: InputMaybe<BooleanFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FeedbackDocumentTypeInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  hintPicture?: InputMaybe<Scalars['ID']['input']>;
  numberRequired?: InputMaybe<Scalars['Boolean']['input']>;
  seriesRequired?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackDocumentTypeRelationResponseCollection = {
  __typename?: 'FeedbackDocumentTypeRelationResponseCollection';
  data: Array<FeedbackDocumentTypeEntity>;
};

export type FeedbackTopic = {
  __typename?: 'FeedbackTopic';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<FeedbackTopicRelationResponseCollection>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type FeedbackTopicLocalizationsArgs = {
  filters?: InputMaybe<FeedbackTopicFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FeedbackTopicEntity = {
  __typename?: 'FeedbackTopicEntity';
  attributes?: Maybe<FeedbackTopic>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type FeedbackTopicEntityResponse = {
  __typename?: 'FeedbackTopicEntityResponse';
  data?: Maybe<FeedbackTopicEntity>;
};

export type FeedbackTopicEntityResponseCollection = {
  __typename?: 'FeedbackTopicEntityResponseCollection';
  data: Array<FeedbackTopicEntity>;
  meta: ResponseCollectionMeta;
};

export type FeedbackTopicFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<FeedbackTopicFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<FeedbackTopicFiltersInput>;
  not?: InputMaybe<FeedbackTopicFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<FeedbackTopicFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type FeedbackTopicInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeedbackTopicRelationResponseCollection = {
  __typename?: 'FeedbackTopicRelationResponseCollection';
  data: Array<FeedbackTopicEntity>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GalleryPage = {
  __typename?: 'GalleryPage';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<GalleryPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GalleryPageEntity = {
  __typename?: 'GalleryPageEntity';
  attributes?: Maybe<GalleryPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type GalleryPageEntityResponse = {
  __typename?: 'GalleryPageEntityResponse';
  data?: Maybe<GalleryPageEntity>;
};

export type GalleryPageInput = {
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GalleryPageRelationResponseCollection = {
  __typename?: 'GalleryPageRelationResponseCollection';
  data: Array<GalleryPageEntity>;
};

export type GenericMorph = ComponentAccordionAccordionItem | ComponentContentAccordion | ComponentContentAdvantageItem | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentStepContent | ComponentContentStepItem | ComponentContentSteps | ComponentFeedbackFeedbackForm | ComponentLayoutMenuCategory | ComponentLayoutSearchQueries | ComponentLayoutSocialNetwork | ComponentMainBanner | ComponentMainMainServices | ComponentMediaImage | ComponentMediaRutube | ComponentMediaSelfHostedVideo | ComponentNavigationDocument | ComponentNavigationGroupLinks | ComponentNavigationLink | ComponentNavigationMenuItem | ComponentNavigationMenuItemWithAsset | ComponentNavigationMenuItemWithIcon | ComponentNewsAsideNews | ContactPage | DocumentPage | FeedbackDocumentType | FeedbackTopic | GalleryPage | HolidayBanner | I18NLocale | InfoPage | Layout | MainPage | MediaPage | NewsListPage | NewsPage | PrivacyPolicyPage | ServiceInnPage | ServiceInvoicePage | ServicePaymentPage | ServiceStatusPage | ServicesMenu | ServicesPageCommon | UploadFile | UploadFolder | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser;

export type HolidayBanner = {
  __typename?: 'HolidayBanner';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endsAt: Scalars['DateTime']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<HolidayBannerRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  startsAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  type: Enum_Holidaybanner_Type;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HolidayBannerLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type HolidayBannerEntity = {
  __typename?: 'HolidayBannerEntity';
  attributes?: Maybe<HolidayBanner>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HolidayBannerEntityResponse = {
  __typename?: 'HolidayBannerEntityResponse';
  data?: Maybe<HolidayBannerEntity>;
};

export type HolidayBannerInput = {
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Holidaybanner_Type>;
};

export type HolidayBannerRelationResponseCollection = {
  __typename?: 'HolidayBannerRelationResponseCollection';
  data: Array<HolidayBannerEntity>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type InfoPage = {
  __typename?: 'InfoPage';
  buttons?: Maybe<Array<Maybe<ComponentNavigationMenuItemWithAsset>>>;
  content: Array<Maybe<InfoPageContentDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documents?: Maybe<Array<Maybe<ComponentNavigationDocument>>>;
  links?: Maybe<Array<Maybe<ComponentNavigationMenuItem>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<InfoPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type InfoPageButtonsArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type InfoPageDocumentsArgs = {
  filters?: InputMaybe<ComponentNavigationDocumentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type InfoPageLinksArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type InfoPageLocalizationsArgs = {
  filters?: InputMaybe<InfoPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InfoPageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | ComponentFeedbackFeedbackForm | ComponentMediaSelfHostedVideo | Error;

export type InfoPageEntity = {
  __typename?: 'InfoPageEntity';
  attributes?: Maybe<InfoPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type InfoPageEntityResponse = {
  __typename?: 'InfoPageEntityResponse';
  data?: Maybe<InfoPageEntity>;
};

export type InfoPageEntityResponseCollection = {
  __typename?: 'InfoPageEntityResponseCollection';
  data: Array<InfoPageEntity>;
  meta: ResponseCollectionMeta;
};

export type InfoPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<InfoPageFiltersInput>>>;
  buttons?: InputMaybe<ComponentNavigationMenuItemWithAssetFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documents?: InputMaybe<ComponentNavigationDocumentFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  links?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<InfoPageFiltersInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<InfoPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<InfoPageFiltersInput>>>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type InfoPageInput = {
  buttons?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemWithAssetInput>>>;
  content?: InputMaybe<Array<Scalars['InfoPageContentDynamicZoneInput']['input']>>;
  documents?: InputMaybe<Array<InputMaybe<ComponentNavigationDocumentInput>>>;
  links?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemInput>>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InfoPageRelationResponseCollection = {
  __typename?: 'InfoPageRelationResponseCollection';
  data: Array<InfoPageEntity>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Layout = {
  __typename?: 'Layout';
  address: Scalars['String']['output'];
  copyright: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  footerDocuments?: Maybe<DocumentPageRelationResponseCollection>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<LayoutRelationResponseCollection>;
  menuCategories: Array<Maybe<ComponentLayoutMenuCategory>>;
  phone: Scalars['String']['output'];
  phoneDescription: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  searchLabel?: Maybe<Scalars['String']['output']>;
  searchQueries?: Maybe<Array<Maybe<ComponentLayoutSearchQueries>>>;
  socialLinks?: Maybe<Array<Maybe<ComponentLayoutSocialNetwork>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workingHours: Scalars['String']['output'];
};


export type LayoutFooterDocumentsArgs = {
  filters?: InputMaybe<DocumentPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LayoutLocalizationsArgs = {
  filters?: InputMaybe<LayoutFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LayoutMenuCategoriesArgs = {
  filters?: InputMaybe<ComponentLayoutMenuCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LayoutSearchQueriesArgs = {
  filters?: InputMaybe<ComponentLayoutSearchQueriesFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LayoutSocialLinksArgs = {
  filters?: InputMaybe<ComponentLayoutSocialNetworkFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LayoutEntity = {
  __typename?: 'LayoutEntity';
  attributes?: Maybe<Layout>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type LayoutEntityResponse = {
  __typename?: 'LayoutEntityResponse';
  data?: Maybe<LayoutEntity>;
};

export type LayoutEntityResponseCollection = {
  __typename?: 'LayoutEntityResponseCollection';
  data: Array<LayoutEntity>;
  meta: ResponseCollectionMeta;
};

export type LayoutFiltersInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<LayoutFiltersInput>>>;
  copyright?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  footerDocuments?: InputMaybe<DocumentPageFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<LayoutFiltersInput>;
  menuCategories?: InputMaybe<ComponentLayoutMenuCategoryFiltersInput>;
  not?: InputMaybe<LayoutFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<LayoutFiltersInput>>>;
  phone?: InputMaybe<StringFilterInput>;
  phoneDescription?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  searchLabel?: InputMaybe<StringFilterInput>;
  searchQueries?: InputMaybe<ComponentLayoutSearchQueriesFiltersInput>;
  socialLinks?: InputMaybe<ComponentLayoutSocialNetworkFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workingHours?: InputMaybe<StringFilterInput>;
};

export type LayoutInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  copyright?: InputMaybe<Scalars['String']['input']>;
  footerDocuments?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  menuCategories?: InputMaybe<Array<InputMaybe<ComponentLayoutMenuCategoryInput>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneDescription?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  searchLabel?: InputMaybe<Scalars['String']['input']>;
  searchQueries?: InputMaybe<Array<InputMaybe<ComponentLayoutSearchQueriesInput>>>;
  socialLinks?: InputMaybe<Array<InputMaybe<ComponentLayoutSocialNetworkInput>>>;
  workingHours?: InputMaybe<Scalars['String']['input']>;
};

export type LayoutRelationResponseCollection = {
  __typename?: 'LayoutRelationResponseCollection';
  data: Array<LayoutEntity>;
};

export enum LinkType {
  ContactPage = 'ContactPage',
  ExternalLink = 'ExternalLink',
  GalleryPage = 'GalleryPage',
  InfoPage = 'InfoPage',
  MediaPage = 'MediaPage',
  NewsListPage = 'NewsListPage',
  NewsPage = 'NewsPage',
  ServicePage = 'ServicePage'
}

export type MainPage = {
  __typename?: 'MainPage';
  FAQ: Array<Maybe<ComponentAccordionAccordionItem>>;
  FAQTitle: Scalars['String']['output'];
  additionalMenu: Array<Maybe<ComponentNavigationMenuItem>>;
  additionalMenuTitle: Scalars['String']['output'];
  addressLabel: Scalars['String']['output'];
  addressLink?: Maybe<ComponentNavigationLink>;
  banner?: Maybe<Array<Maybe<ComponentMainBanner>>>;
  bannerAutoPlayInterval: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feedbackForm?: Maybe<ComponentFeedbackFeedbackForm>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<MainPageRelationResponseCollection>;
  mainServices?: Maybe<ComponentMainMainServices>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  newsTitle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MainPageFaqArgs = {
  filters?: InputMaybe<ComponentAccordionAccordionItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MainPageAdditionalMenuArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MainPageBannerArgs = {
  filters?: InputMaybe<ComponentMainBannerFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MainPageEntity = {
  __typename?: 'MainPageEntity';
  attributes?: Maybe<MainPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MainPageEntityResponse = {
  __typename?: 'MainPageEntityResponse';
  data?: Maybe<MainPageEntity>;
};

export type MainPageInput = {
  FAQ?: InputMaybe<Array<InputMaybe<ComponentAccordionAccordionItemInput>>>;
  FAQTitle?: InputMaybe<Scalars['String']['input']>;
  additionalMenu?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemInput>>>;
  additionalMenuTitle?: InputMaybe<Scalars['String']['input']>;
  addressLabel?: InputMaybe<Scalars['String']['input']>;
  addressLink?: InputMaybe<ComponentNavigationLinkInput>;
  banner?: InputMaybe<Array<InputMaybe<ComponentMainBannerInput>>>;
  bannerAutoPlayInterval?: InputMaybe<Scalars['Int']['input']>;
  feedbackForm?: InputMaybe<ComponentFeedbackFeedbackFormInput>;
  mainServices?: InputMaybe<ComponentMainMainServicesInput>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  newsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type MainPageRelationResponseCollection = {
  __typename?: 'MainPageRelationResponseCollection';
  data: Array<MainPageEntity>;
};

export type MediaPage = {
  __typename?: 'MediaPage';
  content?: Maybe<Array<Maybe<MediaPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  gallery?: Maybe<Array<Maybe<MediaPageGalleryDynamicZone>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<MediaPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  preview: UploadFileEntityResponse;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MediaPageLocalizationsArgs = {
  filters?: InputMaybe<MediaPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MediaPageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type MediaPageEntity = {
  __typename?: 'MediaPageEntity';
  attributes?: Maybe<MediaPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MediaPageEntityResponse = {
  __typename?: 'MediaPageEntityResponse';
  data?: Maybe<MediaPageEntity>;
};

export type MediaPageEntityResponseCollection = {
  __typename?: 'MediaPageEntityResponseCollection';
  data: Array<MediaPageEntity>;
  meta: ResponseCollectionMeta;
};

export type MediaPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<MediaPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<MediaPageFiltersInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<MediaPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<MediaPageFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type MediaPageGalleryDynamicZone = ComponentMediaImage | ComponentMediaRutube | ComponentMediaSelfHostedVideo | Error;

export type MediaPageInput = {
  content?: InputMaybe<Array<Scalars['MediaPageContentDynamicZoneInput']['input']>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  gallery?: InputMaybe<Array<Scalars['MediaPageGalleryDynamicZoneInput']['input']>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaPageRelationResponseCollection = {
  __typename?: 'MediaPageRelationResponseCollection';
  data: Array<MediaPageEntity>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createContactPage?: Maybe<ContactPageEntityResponse>;
  createContactPageLocalization?: Maybe<ContactPageEntityResponse>;
  createDocumentPage?: Maybe<DocumentPageEntityResponse>;
  createDocumentPageLocalization?: Maybe<DocumentPageEntityResponse>;
  createFeedbackDocumentType?: Maybe<FeedbackDocumentTypeEntityResponse>;
  createFeedbackDocumentTypeLocalization?: Maybe<FeedbackDocumentTypeEntityResponse>;
  createFeedbackTopic?: Maybe<FeedbackTopicEntityResponse>;
  createFeedbackTopicLocalization?: Maybe<FeedbackTopicEntityResponse>;
  createGalleryPageLocalization?: Maybe<GalleryPageEntityResponse>;
  createHolidayBannerLocalization?: Maybe<HolidayBannerEntityResponse>;
  createInfoPage?: Maybe<InfoPageEntityResponse>;
  createInfoPageLocalization?: Maybe<InfoPageEntityResponse>;
  createLayout?: Maybe<LayoutEntityResponse>;
  createLayoutLocalization?: Maybe<LayoutEntityResponse>;
  createMainPageLocalization?: Maybe<MainPageEntityResponse>;
  createMediaPage?: Maybe<MediaPageEntityResponse>;
  createMediaPageLocalization?: Maybe<MediaPageEntityResponse>;
  createNewsListPageLocalization?: Maybe<NewsListPageEntityResponse>;
  createNewsPage?: Maybe<NewsPageEntityResponse>;
  createNewsPageLocalization?: Maybe<NewsPageEntityResponse>;
  createPrivacyPolicyPageLocalization?: Maybe<PrivacyPolicyPageEntityResponse>;
  createServiceInnPageLocalization?: Maybe<ServiceInnPageEntityResponse>;
  createServiceInvoicePageLocalization?: Maybe<ServiceInvoicePageEntityResponse>;
  createServicePaymentPageLocalization?: Maybe<ServicePaymentPageEntityResponse>;
  createServiceStatusPageLocalization?: Maybe<ServiceStatusPageEntityResponse>;
  createServicesMenuLocalization?: Maybe<ServicesMenuEntityResponse>;
  createServicesPageCommonLocalization?: Maybe<ServicesPageCommonEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  createUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteContactPage?: Maybe<ContactPageEntityResponse>;
  deleteDocumentPage?: Maybe<DocumentPageEntityResponse>;
  deleteFeedbackDocumentType?: Maybe<FeedbackDocumentTypeEntityResponse>;
  deleteFeedbackTopic?: Maybe<FeedbackTopicEntityResponse>;
  deleteGalleryPage?: Maybe<GalleryPageEntityResponse>;
  deleteHolidayBanner?: Maybe<HolidayBannerEntityResponse>;
  deleteInfoPage?: Maybe<InfoPageEntityResponse>;
  deleteLayout?: Maybe<LayoutEntityResponse>;
  deleteMainPage?: Maybe<MainPageEntityResponse>;
  deleteMediaPage?: Maybe<MediaPageEntityResponse>;
  deleteNewsListPage?: Maybe<NewsListPageEntityResponse>;
  deleteNewsPage?: Maybe<NewsPageEntityResponse>;
  deletePrivacyPolicyPage?: Maybe<PrivacyPolicyPageEntityResponse>;
  deleteServiceInnPage?: Maybe<ServiceInnPageEntityResponse>;
  deleteServiceInvoicePage?: Maybe<ServiceInvoicePageEntityResponse>;
  deleteServicePaymentPage?: Maybe<ServicePaymentPageEntityResponse>;
  deleteServiceStatusPage?: Maybe<ServiceStatusPageEntityResponse>;
  deleteServicesMenu?: Maybe<ServicesMenuEntityResponse>;
  deleteServicesPageCommon?: Maybe<ServicesPageCommonEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateContactPage?: Maybe<ContactPageEntityResponse>;
  updateDocumentPage?: Maybe<DocumentPageEntityResponse>;
  updateFeedbackDocumentType?: Maybe<FeedbackDocumentTypeEntityResponse>;
  updateFeedbackTopic?: Maybe<FeedbackTopicEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateGalleryPage?: Maybe<GalleryPageEntityResponse>;
  updateHolidayBanner?: Maybe<HolidayBannerEntityResponse>;
  updateInfoPage?: Maybe<InfoPageEntityResponse>;
  updateLayout?: Maybe<LayoutEntityResponse>;
  updateMainPage?: Maybe<MainPageEntityResponse>;
  updateMediaPage?: Maybe<MediaPageEntityResponse>;
  updateNewsListPage?: Maybe<NewsListPageEntityResponse>;
  updateNewsPage?: Maybe<NewsPageEntityResponse>;
  updatePrivacyPolicyPage?: Maybe<PrivacyPolicyPageEntityResponse>;
  updateServiceInnPage?: Maybe<ServiceInnPageEntityResponse>;
  updateServiceInvoicePage?: Maybe<ServiceInvoicePageEntityResponse>;
  updateServicePaymentPage?: Maybe<ServicePaymentPageEntityResponse>;
  updateServiceStatusPage?: Maybe<ServiceStatusPageEntityResponse>;
  updateServicesMenu?: Maybe<ServicesMenuEntityResponse>;
  updateServicesPageCommon?: Maybe<ServicesPageCommonEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  updateUploadFolder?: Maybe<UploadFolderEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  upload: UploadFileEntityResponse;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateContactPageArgs = {
  data: ContactPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateContactPageLocalizationArgs = {
  data?: InputMaybe<ContactPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateDocumentPageArgs = {
  data: DocumentPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateDocumentPageLocalizationArgs = {
  data?: InputMaybe<DocumentPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFeedbackDocumentTypeArgs = {
  data: FeedbackDocumentTypeInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFeedbackDocumentTypeLocalizationArgs = {
  data?: InputMaybe<FeedbackDocumentTypeInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFeedbackTopicArgs = {
  data: FeedbackTopicInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateFeedbackTopicLocalizationArgs = {
  data?: InputMaybe<FeedbackTopicInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateGalleryPageLocalizationArgs = {
  data?: InputMaybe<GalleryPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateHolidayBannerLocalizationArgs = {
  data?: InputMaybe<HolidayBannerInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInfoPageArgs = {
  data: InfoPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateInfoPageLocalizationArgs = {
  data?: InputMaybe<InfoPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLayoutArgs = {
  data: LayoutInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateLayoutLocalizationArgs = {
  data?: InputMaybe<LayoutInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateMainPageLocalizationArgs = {
  data?: InputMaybe<MainPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateMediaPageArgs = {
  data: MediaPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateMediaPageLocalizationArgs = {
  data?: InputMaybe<MediaPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNewsListPageLocalizationArgs = {
  data?: InputMaybe<NewsListPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNewsPageArgs = {
  data: NewsPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNewsPageLocalizationArgs = {
  data?: InputMaybe<NewsPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreatePrivacyPolicyPageLocalizationArgs = {
  data?: InputMaybe<PrivacyPolicyPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateServiceInnPageLocalizationArgs = {
  data?: InputMaybe<ServiceInnPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateServiceInvoicePageLocalizationArgs = {
  data?: InputMaybe<ServiceInvoicePageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateServicePaymentPageLocalizationArgs = {
  data?: InputMaybe<ServicePaymentPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateServiceStatusPageLocalizationArgs = {
  data?: InputMaybe<ServiceStatusPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateServicesMenuLocalizationArgs = {
  data?: InputMaybe<ServicesMenuInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateServicesPageCommonLocalizationArgs = {
  data?: InputMaybe<ServicesPageCommonInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUploadFolderArgs = {
  data: UploadFolderInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteContactPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteDocumentPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteFeedbackDocumentTypeArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteFeedbackTopicArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteGalleryPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteHolidayBannerArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteInfoPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteLayoutArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteMainPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteMediaPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteNewsListPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteNewsPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeletePrivacyPolicyPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteServiceInnPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteServiceInvoicePageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteServicePaymentPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteServiceStatusPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteServicesMenuArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteServicesPageCommonArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUploadFolderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateContactPageArgs = {
  data: ContactPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateDocumentPageArgs = {
  data: DocumentPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateFeedbackDocumentTypeArgs = {
  data: FeedbackDocumentTypeInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateFeedbackTopicArgs = {
  data: FeedbackTopicInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateGalleryPageArgs = {
  data: GalleryPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateHolidayBannerArgs = {
  data: HolidayBannerInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateInfoPageArgs = {
  data: InfoPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateLayoutArgs = {
  data: LayoutInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateMainPageArgs = {
  data: MainPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateMediaPageArgs = {
  data: MediaPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateNewsListPageArgs = {
  data: NewsListPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateNewsPageArgs = {
  data: NewsPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdatePrivacyPolicyPageArgs = {
  data: PrivacyPolicyPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateServiceInnPageArgs = {
  data: ServiceInnPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateServiceInvoicePageArgs = {
  data: ServiceInvoicePageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateServicePaymentPageArgs = {
  data: ServicePaymentPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateServiceStatusPageArgs = {
  data: ServiceStatusPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateServicesMenuArgs = {
  data: ServicesMenuInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateServicesPageCommonArgs = {
  data: ServicesPageCommonInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUploadFolderArgs = {
  data: UploadFolderInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type NewsListPage = {
  __typename?: 'NewsListPage';
  asideNews?: Maybe<Array<Maybe<ComponentNewsAsideNews>>>;
  categoryLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NewsListPageRelationResponseCollection>;
  mainNewsSlug: Scalars['String']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  pageSize: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NewsListPageAsideNewsArgs = {
  filters?: InputMaybe<ComponentNewsAsideNewsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NewsListPageEntity = {
  __typename?: 'NewsListPageEntity';
  attributes?: Maybe<NewsListPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NewsListPageEntityResponse = {
  __typename?: 'NewsListPageEntityResponse';
  data?: Maybe<NewsListPageEntity>;
};

export type NewsListPageInput = {
  asideNews?: InputMaybe<Array<InputMaybe<ComponentNewsAsideNewsInput>>>;
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  mainNewsSlug?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsListPageRelationResponseCollection = {
  __typename?: 'NewsListPageRelationResponseCollection';
  data: Array<NewsListPageEntity>;
};

export type NewsPage = {
  __typename?: 'NewsPage';
  content: Array<Maybe<NewsPageContentDynamicZone>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  image: UploadFileEntityResponse;
  imageLabel?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NewsPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NewsPageLocalizationsArgs = {
  filters?: InputMaybe<NewsPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NewsPageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type NewsPageEntity = {
  __typename?: 'NewsPageEntity';
  attributes?: Maybe<NewsPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NewsPageEntityResponse = {
  __typename?: 'NewsPageEntityResponse';
  data?: Maybe<NewsPageEntity>;
};

export type NewsPageEntityResponseCollection = {
  __typename?: 'NewsPageEntityResponseCollection';
  data: Array<NewsPageEntity>;
  meta: ResponseCollectionMeta;
};

export type NewsPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NewsPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  date?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  imageLabel?: InputMaybe<StringFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<NewsPageFiltersInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<NewsPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NewsPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NewsPageInput = {
  content?: InputMaybe<Array<Scalars['NewsPageContentDynamicZoneInput']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  imageLabel?: InputMaybe<Scalars['String']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NewsPageRelationResponseCollection = {
  __typename?: 'NewsPageRelationResponseCollection';
  data: Array<NewsPageEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type PrivacyPolicyPage = {
  __typename?: 'PrivacyPolicyPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentPage?: Maybe<DocumentPageEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<PrivacyPolicyPageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PrivacyPolicyPageEntity = {
  __typename?: 'PrivacyPolicyPageEntity';
  attributes?: Maybe<PrivacyPolicyPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type PrivacyPolicyPageEntityResponse = {
  __typename?: 'PrivacyPolicyPageEntityResponse';
  data?: Maybe<PrivacyPolicyPageEntity>;
};

export type PrivacyPolicyPageInput = {
  documentPage?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PrivacyPolicyPageRelationResponseCollection = {
  __typename?: 'PrivacyPolicyPageRelationResponseCollection';
  data: Array<PrivacyPolicyPageEntity>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  contactPage?: Maybe<ContactPageEntityResponse>;
  contactPages?: Maybe<ContactPageEntityResponseCollection>;
  documentPage?: Maybe<DocumentPageEntityResponse>;
  documentPages?: Maybe<DocumentPageEntityResponseCollection>;
  feedbackDocumentType?: Maybe<FeedbackDocumentTypeEntityResponse>;
  feedbackDocumentTypes?: Maybe<FeedbackDocumentTypeEntityResponseCollection>;
  feedbackTopic?: Maybe<FeedbackTopicEntityResponse>;
  feedbackTopics?: Maybe<FeedbackTopicEntityResponseCollection>;
  galleryPage?: Maybe<GalleryPageEntityResponse>;
  holidayBanner?: Maybe<HolidayBannerEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  infoPage?: Maybe<InfoPageEntityResponse>;
  infoPages?: Maybe<InfoPageEntityResponseCollection>;
  layout?: Maybe<LayoutEntityResponse>;
  layouts?: Maybe<LayoutEntityResponseCollection>;
  mainPage?: Maybe<MainPageEntityResponse>;
  me?: Maybe<UsersPermissionsMe>;
  mediaPage?: Maybe<MediaPageEntityResponse>;
  mediaPages?: Maybe<MediaPageEntityResponseCollection>;
  newsListPage?: Maybe<NewsListPageEntityResponse>;
  newsPage?: Maybe<NewsPageEntityResponse>;
  newsPages?: Maybe<NewsPageEntityResponseCollection>;
  privacyPolicyPage?: Maybe<PrivacyPolicyPageEntityResponse>;
  serviceInnPage?: Maybe<ServiceInnPageEntityResponse>;
  serviceInvoicePage?: Maybe<ServiceInvoicePageEntityResponse>;
  servicePaymentPage?: Maybe<ServicePaymentPageEntityResponse>;
  serviceStatusPage?: Maybe<ServiceStatusPageEntityResponse>;
  servicesMenu?: Maybe<ServicesMenuEntityResponse>;
  servicesPageCommon?: Maybe<ServicesPageCommonEntityResponse>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<UploadFolderEntityResponse>;
  uploadFolders?: Maybe<UploadFolderEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
};


export type QueryContactPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryContactPagesArgs = {
  filters?: InputMaybe<ContactPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDocumentPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryDocumentPagesArgs = {
  filters?: InputMaybe<DocumentPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeedbackDocumentTypeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryFeedbackDocumentTypesArgs = {
  filters?: InputMaybe<FeedbackDocumentTypeFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFeedbackTopicArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryFeedbackTopicsArgs = {
  filters?: InputMaybe<FeedbackTopicFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGalleryPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryHolidayBannerArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryInfoPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryInfoPagesArgs = {
  filters?: InputMaybe<InfoPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryLayoutArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryLayoutsArgs = {
  filters?: InputMaybe<LayoutFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMainPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryMediaPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryMediaPagesArgs = {
  filters?: InputMaybe<MediaPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNewsListPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryNewsPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryNewsPagesArgs = {
  filters?: InputMaybe<NewsPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPrivacyPolicyPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryServiceInnPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryServiceInvoicePageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryServicePaymentPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryServiceStatusPageArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryServicesMenuArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryServicesPageCommonArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFoldersArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type ServiceInnPage = {
  __typename?: 'ServiceInnPage';
  bottomContent?: Maybe<Array<Maybe<ServiceInnPageBottomContentDynamicZone>>>;
  content?: Maybe<Array<Maybe<ServiceInnPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ServiceInnPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceInnPageBottomContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServiceInnPageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServiceInnPageEntity = {
  __typename?: 'ServiceInnPageEntity';
  attributes?: Maybe<ServiceInnPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ServiceInnPageEntityResponse = {
  __typename?: 'ServiceInnPageEntityResponse';
  data?: Maybe<ServiceInnPageEntity>;
};

export type ServiceInnPageInput = {
  bottomContent?: InputMaybe<Array<Scalars['ServiceInnPageBottomContentDynamicZoneInput']['input']>>;
  content?: InputMaybe<Array<Scalars['ServiceInnPageContentDynamicZoneInput']['input']>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceInnPageRelationResponseCollection = {
  __typename?: 'ServiceInnPageRelationResponseCollection';
  data: Array<ServiceInnPageEntity>;
};

export type ServiceInvoicePage = {
  __typename?: 'ServiceInvoicePage';
  bottomContent?: Maybe<Array<Maybe<ServiceInvoicePageBottomContentDynamicZone>>>;
  content?: Maybe<Array<Maybe<ServiceInvoicePageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ServiceInvoicePageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceInvoicePageBottomContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServiceInvoicePageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServiceInvoicePageEntity = {
  __typename?: 'ServiceInvoicePageEntity';
  attributes?: Maybe<ServiceInvoicePage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ServiceInvoicePageEntityResponse = {
  __typename?: 'ServiceInvoicePageEntityResponse';
  data?: Maybe<ServiceInvoicePageEntity>;
};

export type ServiceInvoicePageInput = {
  bottomContent?: InputMaybe<Array<Scalars['ServiceInvoicePageBottomContentDynamicZoneInput']['input']>>;
  content?: InputMaybe<Array<Scalars['ServiceInvoicePageContentDynamicZoneInput']['input']>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceInvoicePageRelationResponseCollection = {
  __typename?: 'ServiceInvoicePageRelationResponseCollection';
  data: Array<ServiceInvoicePageEntity>;
};

export type ServicePaymentPage = {
  __typename?: 'ServicePaymentPage';
  bottomContent?: Maybe<Array<Maybe<ServicePaymentPageBottomContentDynamicZone>>>;
  content?: Maybe<Array<Maybe<ServicePaymentPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ServicePaymentPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServicePaymentPageBottomContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServicePaymentPageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServicePaymentPageEntity = {
  __typename?: 'ServicePaymentPageEntity';
  attributes?: Maybe<ServicePaymentPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ServicePaymentPageEntityResponse = {
  __typename?: 'ServicePaymentPageEntityResponse';
  data?: Maybe<ServicePaymentPageEntity>;
};

export type ServicePaymentPageInput = {
  bottomContent?: InputMaybe<Array<Scalars['ServicePaymentPageBottomContentDynamicZoneInput']['input']>>;
  content?: InputMaybe<Array<Scalars['ServicePaymentPageContentDynamicZoneInput']['input']>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ServicePaymentPageRelationResponseCollection = {
  __typename?: 'ServicePaymentPageRelationResponseCollection';
  data: Array<ServicePaymentPageEntity>;
};

export type ServiceStatusPage = {
  __typename?: 'ServiceStatusPage';
  bottomContent?: Maybe<Array<Maybe<ServiceStatusPageBottomContentDynamicZone>>>;
  content?: Maybe<Array<Maybe<ServiceStatusPageContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ServiceStatusPageRelationResponseCollection>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ServiceStatusPageBottomContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServiceStatusPageContentDynamicZone = ComponentContentAccordion | ComponentContentAdvantages | ComponentContentImportantInfo | ComponentContentLinks | ComponentContentMap | ComponentContentMarkdown | ComponentContentOnSurface | ComponentContentSteps | Error;

export type ServiceStatusPageEntity = {
  __typename?: 'ServiceStatusPageEntity';
  attributes?: Maybe<ServiceStatusPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ServiceStatusPageEntityResponse = {
  __typename?: 'ServiceStatusPageEntityResponse';
  data?: Maybe<ServiceStatusPageEntity>;
};

export type ServiceStatusPageInput = {
  bottomContent?: InputMaybe<Array<Scalars['ServiceStatusPageBottomContentDynamicZoneInput']['input']>>;
  content?: InputMaybe<Array<Scalars['ServiceStatusPageContentDynamicZoneInput']['input']>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceStatusPageRelationResponseCollection = {
  __typename?: 'ServiceStatusPageRelationResponseCollection';
  data: Array<ServiceStatusPageEntity>;
};

export type ServicesMenu = {
  __typename?: 'ServicesMenu';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ServicesMenuRelationResponseCollection>;
  menu: Array<Maybe<ComponentNavigationMenuItem>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ServicesMenuMenuArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServicesMenuEntity = {
  __typename?: 'ServicesMenuEntity';
  attributes?: Maybe<ServicesMenu>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ServicesMenuEntityResponse = {
  __typename?: 'ServicesMenuEntityResponse';
  data?: Maybe<ServicesMenuEntity>;
};

export type ServicesMenuInput = {
  menu?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesMenuRelationResponseCollection = {
  __typename?: 'ServicesMenuRelationResponseCollection';
  data: Array<ServicesMenuEntity>;
};

export type ServicesPageCommon = {
  __typename?: 'ServicesPageCommon';
  categoryLabel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  links?: Maybe<Array<Maybe<ComponentNavigationMenuItem>>>;
  linksLabel?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ServicesPageCommonRelationResponseCollection>;
  slugInn: Scalars['String']['output'];
  slugInvoice: Scalars['String']['output'];
  slugPayment: Scalars['String']['output'];
  slugStatus: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ServicesPageCommonLinksArgs = {
  filters?: InputMaybe<ComponentNavigationMenuItemFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ServicesPageCommonEntity = {
  __typename?: 'ServicesPageCommonEntity';
  attributes?: Maybe<ServicesPageCommon>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ServicesPageCommonEntityResponse = {
  __typename?: 'ServicesPageCommonEntityResponse';
  data?: Maybe<ServicesPageCommonEntity>;
};

export type ServicesPageCommonInput = {
  categoryLabel?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentNavigationMenuItemInput>>>;
  linksLabel?: InputMaybe<Scalars['String']['input']>;
  slugInn?: InputMaybe<Scalars['String']['input']>;
  slugInvoice?: InputMaybe<Scalars['String']['input']>;
  slugPayment?: InputMaybe<Scalars['String']['input']>;
  slugStatus?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesPageCommonRelationResponseCollection = {
  __typename?: 'ServicesPageCommonRelationResponseCollection';
  data: Array<ServicesPageCommonEntity>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  folder?: InputMaybe<UploadFolderFiltersInput>;
  folderPath?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Scalars['ID']['input']>;
  folderPath?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<UploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<UploadFileRelationResponseCollection>;
  name: Scalars['String']['output'];
  parent?: Maybe<UploadFolderEntityResponse>;
  path: Scalars['String']['output'];
  pathId: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UploadFolderChildrenArgs = {
  filters?: InputMaybe<UploadFolderFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UploadFolderFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<UploadFolder>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<UploadFolderEntity>;
};

export type UploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<UploadFolderEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  children?: InputMaybe<UploadFolderFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  files?: InputMaybe<UploadFileFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFolderFiltersInput>>>;
  parent?: InputMaybe<UploadFolderFiltersInput>;
  path?: InputMaybe<StringFilterInput>;
  pathId?: InputMaybe<IntFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  pathId?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<UploadFolderEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type HolidayBannerQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type HolidayBannerQuery = { __typename?: 'Query', holidayBanner?: { __typename?: 'HolidayBannerEntityResponse', data?: { __typename?: 'HolidayBannerEntity', id?: string | null, attributes?: { __typename?: 'HolidayBanner', type: Enum_Holidaybanner_Type, title: string, startsAt: any, endsAt: any, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null } | null } | null };

export type ContactPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ContactPageQuery = { __typename?: 'Query', contactPage?: { __typename?: 'ContactPageEntityResponse', data?: { __typename?: 'ContactPageEntity', id?: string | null, attributes?: { __typename?: 'ContactPage', metaDescription?: string | null, title: string, slug: string, addressLabel: string, address: string, workingHoursLabel: string, workingHours: string, phoneLabel: string, phone: string, zoom?: number | null, coordinates: string, button?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | null } | null } | null };

export type DocumentPageQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type DocumentPageQuery = { __typename?: 'Query', documentPages?: { __typename?: 'DocumentPageEntityResponseCollection', data: Array<{ __typename?: 'DocumentPageEntity', id?: string | null, attributes?: { __typename?: 'DocumentPage', title?: string | null, content?: string | null } | null }> } | null };

export type GalleryPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GalleryPageQuery = { __typename?: 'Query', galleryPage?: { __typename?: 'GalleryPageEntityResponse', data?: { __typename?: 'GalleryPageEntity', id?: string | null, attributes?: { __typename?: 'GalleryPage', title: string, categoryLabel?: string | null, slug: string, metaDescription?: string | null } | null } | null } | null, mediaPages?: { __typename?: 'MediaPageEntityResponseCollection', data: Array<{ __typename?: 'MediaPageEntity', id?: string | null, attributes?: { __typename?: 'MediaPage', slug: string, title: string, preview: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', formats?: any | null, url: string } | null } | null }, gallery?: Array<{ __typename: 'ComponentMediaImage', id: string } | { __typename: 'ComponentMediaRutube', id: string } | { __typename: 'ComponentMediaSelfHostedVideo' } | { __typename: 'Error' } | null> | null } | null }> } | null };

export type MediaPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type MediaPageQuery = { __typename?: 'Query', mediaPage?: { __typename?: 'MediaPageEntityResponse', data?: { __typename?: 'MediaPageEntity', id?: string | null, attributes?: { __typename?: 'MediaPage', title: string, slug: string, metaDescription?: string | null, date?: any | null, content?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null, gallery?: Array<{ __typename: 'ComponentMediaImage', id: string, title?: string | null, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } } | { __typename: 'ComponentMediaRutube', id: string, title?: string | null, videoId: string, preview: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null } | null } | null } } | { __typename: 'ComponentMediaSelfHostedVideo', id: string, title?: string | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, name: string } | null } | null }, videoPreview?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename: 'UploadFile', url: string, formats?: any | null } | null } | null } | null } | { __typename: 'Error' } | null> | null } | null } | null } | null, galleryPage?: { __typename?: 'GalleryPageEntityResponse', data?: { __typename?: 'GalleryPageEntity', id?: string | null, attributes?: { __typename?: 'GalleryPage', title: string, slug: string } | null } | null } | null };

export type InfoPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type InfoPageQuery = { __typename?: 'Query', infoPage?: { __typename?: 'InfoPageEntityResponse', data?: { __typename?: 'InfoPageEntity', id?: string | null, attributes?: { __typename?: 'InfoPage', title: string, slug: string, metaDescription?: string | null, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'ComponentFeedbackFeedbackForm', id: string, active: boolean, feedbackTopicRequired: boolean, feedbackDocTypeRequired: boolean, nameRequired: boolean, surnameRequired: boolean, patronymicRequired: boolean, phoneRequired: boolean, emailRequired: boolean, emailRecipient: string, title?: string | null, titleActive: boolean, feedbackTopics?: { __typename?: 'FeedbackTopicRelationResponseCollection', data: Array<{ __typename?: 'FeedbackTopicEntity', id?: string | null, attributes?: { __typename?: 'FeedbackTopic', title: string } | null }> } | null, feedbackDocTypes?: { __typename?: 'FeedbackDocumentTypeRelationResponseCollection', data: Array<{ __typename?: 'FeedbackDocumentTypeEntity', id?: string | null, attributes?: { __typename?: 'FeedbackDocumentType', title: string, seriesRequired: boolean, numberRequired: boolean, hint?: string | null, hintPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null }> } | null, consentPDAPage?: { __typename?: 'DocumentPageEntityResponse', data?: { __typename?: 'DocumentPageEntity', id?: string | null, attributes?: { __typename?: 'DocumentPage', title?: string | null } | null } | null } | null } | { __typename: 'ComponentMediaSelfHostedVideo', id: string, title?: string | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null }, preview?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | { __typename: 'Error' } | null>, documents?: Array<{ __typename?: 'ComponentNavigationDocument', id: string, title: string, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } } | null> | null, links?: Array<{ __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null> | null, buttons?: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type MainPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type MainPageQuery = { __typename?: 'Query', mainPage?: { __typename?: 'MainPageEntityResponse', data?: { __typename?: 'MainPageEntity', id?: string | null, attributes?: { __typename?: 'MainPage', addressLabel: string, metaDescription?: string | null, bannerAutoPlayInterval: number, additionalMenuTitle: string, FAQTitle: string, newsTitle?: string | null, addressLink?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, banner?: Array<{ __typename?: 'ComponentMainBanner', id: string, text: string, title?: string | null, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null } | null> | null, mainServices?: { __typename?: 'ComponentMainMainServices', id: string, description?: string | null, title: string, allServicesLink?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null, menu: Array<{ __typename?: 'ComponentNavigationMenuItemWithIcon', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string }, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null, additionalMenu: Array<{ __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null>, FAQ: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, title: string, content: string } | null> } | null } | null } | null, servicesMenu?: { __typename?: 'ServicesMenuEntityResponse', data?: { __typename?: 'ServicesMenuEntity', id?: string | null, attributes?: { __typename?: 'ServicesMenu', title: string, menu: Array<{ __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null> } | null } | null } | null, lastNews?: { __typename?: 'NewsPageEntityResponseCollection', data: Array<{ __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null }> } | null };

export type NewsListPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type NewsListPageQuery = { __typename?: 'Query', newsListPage?: { __typename?: 'NewsListPageEntityResponse', data?: { __typename?: 'NewsListPageEntity', id?: string | null, attributes?: { __typename?: 'NewsListPage', title: string, categoryLabel?: string | null, slug: string, mainNewsSlug: string, metaDescription?: string | null, pageSize: number, asideNews?: Array<{ __typename?: 'ComponentNewsAsideNews', id: string, slug: string } | null> | null } | null } | null } | null };

export type NewsListContentQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  asideNews: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type NewsListContentQuery = { __typename?: 'Query', mainNews?: { __typename?: 'NewsPageEntityResponse', data?: { __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', description?: string | null, title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null } | null } | null, asideNews?: { __typename?: 'NewsPageEntityResponseCollection', data: Array<{ __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null }> } | null };

export type NewsListAllQueryVariables = Exact<{
  excludeSlug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}>;


export type NewsListAllQuery = { __typename?: 'Query', allNews?: { __typename?: 'NewsPageEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number } }, data: Array<{ __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', description?: string | null, title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null }> } | null };

export type NewsPageQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type NewsPageQuery = { __typename?: 'Query', newsPage?: { __typename?: 'NewsPageEntityResponse', data?: { __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null } | null } | null, lastNews?: { __typename?: 'NewsPageEntityResponseCollection', data: Array<{ __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null }> } | null };

export type PolicyPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type PolicyPageQuery = { __typename?: 'Query', privacyPolicyPage?: { __typename?: 'PrivacyPolicyPageEntityResponse', data?: { __typename?: 'PrivacyPolicyPageEntity', id?: string | null, attributes?: { __typename?: 'PrivacyPolicyPage', documentPage?: { __typename?: 'DocumentPageEntityResponse', data?: { __typename?: 'DocumentPageEntity', attributes?: { __typename?: 'DocumentPage', title?: string | null, content?: string | null } | null } | null } | null } | null } | null } | null };

export type SearchPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type SearchPageQuery = { __typename?: 'Query', servicesPageCommon?: { __typename?: 'ServicesPageCommonEntityResponse', data?: { __typename?: 'ServicesPageCommonEntity', id?: string | null, attributes?: { __typename?: 'ServicesPageCommon', slugPayment: string, slugInvoice: string, slugInn: string, slugStatus: string, categoryLabel?: string | null } | null } | null } | null };

export type InnPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type InnPageQuery = { __typename?: 'Query', serviceInnPage?: { __typename?: 'ServiceInnPageEntityResponse', data?: { __typename?: 'ServiceInnPageEntity', id?: string | null, attributes?: { __typename?: 'ServiceInnPage', title: string, metaDescription?: string | null, content?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null, bottomContent?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null } | null } | null } | null };

export type InvoicePageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type InvoicePageQuery = { __typename?: 'Query', serviceInvoicePage?: { __typename?: 'ServiceInvoicePageEntityResponse', data?: { __typename?: 'ServiceInvoicePageEntity', id?: string | null, attributes?: { __typename?: 'ServiceInvoicePage', title: string, metaDescription?: string | null, content?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null, bottomContent?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null } | null } | null } | null };

export type PaymentPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type PaymentPageQuery = { __typename?: 'Query', servicePaymentPage?: { __typename?: 'ServicePaymentPageEntityResponse', data?: { __typename?: 'ServicePaymentPageEntity', id?: string | null, attributes?: { __typename?: 'ServicePaymentPage', title: string, metaDescription?: string | null, content?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null, bottomContent?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null } | null } | null } | null };

export type ServicePageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type ServicePageQuery = { __typename?: 'Query', servicesPageCommon?: { __typename?: 'ServicesPageCommonEntityResponse', data?: { __typename?: 'ServicesPageCommonEntity', id?: string | null, attributes?: { __typename?: 'ServicesPageCommon', slugPayment: string, slugInvoice: string, slugInn: string, slugStatus: string, categoryLabel?: string | null, linksLabel?: string | null, links?: Array<{ __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null> | null } | null } | null } | null, servicesMenu?: { __typename?: 'ServicesMenuEntityResponse', data?: { __typename?: 'ServicesMenuEntity', id?: string | null, attributes?: { __typename?: 'ServicesMenu', title: string, menu: Array<{ __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null> } | null } | null } | null };

export type StatusPageQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type StatusPageQuery = { __typename?: 'Query', serviceStatusPage?: { __typename?: 'ServiceStatusPageEntityResponse', data?: { __typename?: 'ServiceStatusPageEntity', id?: string | null, attributes?: { __typename?: 'ServiceStatusPage', title: string, metaDescription?: string | null, content?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null, bottomContent?: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> | null } | null } | null } | null };

export type UploadFileEntityResponseFragmentFragment = { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null };

export type NavigationLinkFragmentFragment = { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string };

export type NavigationMenuItemFragmentFragment = { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } };

export type NavigationDocumentFragmentFragment = { __typename?: 'ComponentNavigationDocument', id: string, title: string, media: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } };

export type NavigationMenuItemWithIconFragmentFragment = { __typename?: 'ComponentNavigationMenuItemWithIcon', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string }, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null };

export type NavigationMenuItemWithAssetFragmentFragment = { __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null };

export type AccordionItemFragmentFragment = { __typename?: 'ComponentAccordionAccordionItem', id: string, title: string, content: string };

type DynamicContentFragment_ComponentContentAccordion_Fragment = { __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> };

type DynamicContentFragment_ComponentContentAdvantages_Fragment = { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> };

type DynamicContentFragment_ComponentContentImportantInfo_Fragment = { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string };

type DynamicContentFragment_ComponentContentLinks_Fragment = { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> };

type DynamicContentFragment_ComponentContentMap_Fragment = { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null };

type DynamicContentFragment_ComponentContentMarkdown_Fragment = { __typename: 'ComponentContentMarkdown', id: string, content: string };

type DynamicContentFragment_ComponentContentOnSurface_Fragment = { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string };

type DynamicContentFragment_ComponentContentSteps_Fragment = { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null };

type DynamicContentFragment_ComponentFeedbackFeedbackForm_Fragment = { __typename: 'ComponentFeedbackFeedbackForm', id: string, active: boolean, feedbackTopicRequired: boolean, feedbackDocTypeRequired: boolean, nameRequired: boolean, surnameRequired: boolean, patronymicRequired: boolean, phoneRequired: boolean, emailRequired: boolean, emailRecipient: string, title?: string | null, titleActive: boolean, feedbackTopics?: { __typename?: 'FeedbackTopicRelationResponseCollection', data: Array<{ __typename?: 'FeedbackTopicEntity', id?: string | null, attributes?: { __typename?: 'FeedbackTopic', title: string } | null }> } | null, feedbackDocTypes?: { __typename?: 'FeedbackDocumentTypeRelationResponseCollection', data: Array<{ __typename?: 'FeedbackDocumentTypeEntity', id?: string | null, attributes?: { __typename?: 'FeedbackDocumentType', title: string, seriesRequired: boolean, numberRequired: boolean, hint?: string | null, hintPicture?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null }> } | null, consentPDAPage?: { __typename?: 'DocumentPageEntityResponse', data?: { __typename?: 'DocumentPageEntity', id?: string | null, attributes?: { __typename?: 'DocumentPage', title?: string | null } | null } | null } | null };

type DynamicContentFragment_ComponentMediaSelfHostedVideo_Fragment = { __typename: 'ComponentMediaSelfHostedVideo', id: string, title?: string | null, video: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null }, preview?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

type DynamicContentFragment_Error_Fragment = { __typename: 'Error' };

export type DynamicContentFragmentFragment = DynamicContentFragment_ComponentContentAccordion_Fragment | DynamicContentFragment_ComponentContentAdvantages_Fragment | DynamicContentFragment_ComponentContentImportantInfo_Fragment | DynamicContentFragment_ComponentContentLinks_Fragment | DynamicContentFragment_ComponentContentMap_Fragment | DynamicContentFragment_ComponentContentMarkdown_Fragment | DynamicContentFragment_ComponentContentOnSurface_Fragment | DynamicContentFragment_ComponentContentSteps_Fragment | DynamicContentFragment_ComponentFeedbackFeedbackForm_Fragment | DynamicContentFragment_ComponentMediaSelfHostedVideo_Fragment | DynamicContentFragment_Error_Fragment;

export type NewsPageFragmentFragment = { __typename?: 'NewsPage', title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> };

export type NewsPageEntityFragmentFragment = { __typename?: 'NewsPageEntity', id?: string | null, attributes?: { __typename?: 'NewsPage', title: string, slug: string, metaDescription?: string | null, date: any, imageLabel?: string | null, image: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null }, content: Array<{ __typename: 'ComponentContentAccordion', id: string, title?: string | null, items: Array<{ __typename?: 'ComponentAccordionAccordionItem', id: string, content: string, title: string } | null> } | { __typename: 'ComponentContentAdvantages', id: string, title?: string | null, advantages: Array<{ __typename?: 'ComponentContentAdvantageItem', id: string, title: string, icon?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | { __typename: 'ComponentContentImportantInfo', id: string, description?: string | null, banner: string } | { __typename: 'ComponentContentLinks', id: string, title?: string | null, groups: Array<{ __typename?: 'ComponentNavigationGroupLinks', id: string, groupTitle?: string | null, links: Array<{ __typename?: 'ComponentNavigationMenuItemWithAsset', id: string, title: string, link?: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } | null, asset?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } | null } | null> } | null> } | { __typename: 'ComponentContentMap', id: string, title?: string | null, coordinates: string, zoom?: number | null, link?: { __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null } | { __typename: 'ComponentContentMarkdown', id: string, content: string } | { __typename: 'ComponentContentOnSurface', id: string, title?: string | null, content: string } | { __typename: 'ComponentContentSteps', id: string, title?: string | null, stepItems?: Array<{ __typename?: 'ComponentContentStepItem', id: string, description?: string | null, title?: string | null, steps?: Array<{ __typename?: 'ComponentContentStepContent', id: string, content: string } | null> | null } | null> | null } | { __typename: 'Error' } | null> } | null };

export type LayoutQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LayoutQuery = { __typename?: 'Query', layout?: { __typename?: 'LayoutEntityResponse', data?: { __typename?: 'LayoutEntity', id?: string | null, attributes?: { __typename?: 'Layout', address: string, copyright: string, locale?: string | null, phone: string, phoneDescription: string, workingHours: string, searchLabel?: string | null, menuCategories: Array<{ __typename?: 'ComponentLayoutMenuCategory', id: string, title: string, menuItems: Array<{ __typename?: 'ComponentNavigationMenuItem', id: string, title: string, link: { __typename?: 'ComponentNavigationLink', id: string, type: LinkType, uri: string } } | null> } | null>, socialLinks?: Array<{ __typename?: 'ComponentLayoutSocialNetwork', id: string, title: string, url: string, icon: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, formats?: any | null, width?: number | null, height?: number | null } | null } | null } } | null> | null, footerDocuments?: { __typename?: 'DocumentPageRelationResponseCollection', data: Array<{ __typename?: 'DocumentPageEntity', id?: string | null, attributes?: { __typename?: 'DocumentPage', title?: string | null } | null }> } | null, searchQueries?: Array<{ __typename?: 'ComponentLayoutSearchQueries', id: string, query: string } | null> | null } | null } | null } | null, mainPage?: { __typename?: 'MainPageEntityResponse', data?: { __typename?: 'MainPageEntity', id?: string | null, attributes?: { __typename?: 'MainPage', metaDescription?: string | null } | null } | null } | null, galleryPage?: { __typename?: 'GalleryPageEntityResponse', data?: { __typename?: 'GalleryPageEntity', id?: string | null, attributes?: { __typename?: 'GalleryPage', slug: string } | null } | null } | null, newsListPage?: { __typename?: 'NewsListPageEntityResponse', data?: { __typename?: 'NewsListPageEntity', id?: string | null, attributes?: { __typename?: 'NewsListPage', slug: string } | null } | null } | null };

export type LocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type LocaleQuery = { __typename?: 'Query', layouts?: { __typename?: 'LayoutEntityResponseCollection', data: Array<{ __typename?: 'LayoutEntity', id?: string | null, attributes?: { __typename?: 'Layout', locale?: string | null } | null }> } | null };

export const UploadFileEntityResponseFragmentFragmentDoc = gql`
    fragment UploadFileEntityResponseFragment on UploadFileEntityResponse {
  data {
    id
    attributes {
      url
      formats
      width
      height
    }
  }
}
    `;
export const NavigationDocumentFragmentFragmentDoc = gql`
    fragment NavigationDocumentFragment on ComponentNavigationDocument {
  id
  title
  media {
    ...UploadFileEntityResponseFragment
  }
}
    ${UploadFileEntityResponseFragmentFragmentDoc}`;
export const NavigationLinkFragmentFragmentDoc = gql`
    fragment NavigationLinkFragment on ComponentNavigationLink {
  id
  type
  uri
}
    `;
export const NavigationMenuItemWithIconFragmentFragmentDoc = gql`
    fragment NavigationMenuItemWithIconFragment on ComponentNavigationMenuItemWithIcon {
  id
  title
  link {
    ...NavigationLinkFragment
  }
  icon {
    ...UploadFileEntityResponseFragment
  }
}
    ${NavigationLinkFragmentFragmentDoc}
${UploadFileEntityResponseFragmentFragmentDoc}`;
export const AccordionItemFragmentFragmentDoc = gql`
    fragment AccordionItemFragment on ComponentAccordionAccordionItem {
  id
  title
  content
}
    `;
export const NavigationMenuItemWithAssetFragmentFragmentDoc = gql`
    fragment NavigationMenuItemWithAssetFragment on ComponentNavigationMenuItemWithAsset {
  id
  title
  link {
    ...NavigationLinkFragment
  }
  asset {
    ...UploadFileEntityResponseFragment
  }
}
    ${NavigationLinkFragmentFragmentDoc}
${UploadFileEntityResponseFragmentFragmentDoc}`;
export const NavigationMenuItemFragmentFragmentDoc = gql`
    fragment NavigationMenuItemFragment on ComponentNavigationMenuItem {
  id
  title
  link {
    ...NavigationLinkFragment
  }
}
    ${NavigationLinkFragmentFragmentDoc}`;
export const DynamicContentFragmentFragmentDoc = gql`
    fragment DynamicContentFragment on InfoPageContentDynamicZone {
  __typename
  ... on ComponentContentMarkdown {
    id
    content
  }
  ... on ComponentContentOnSurface {
    id
    title
    content
  }
  ... on ComponentContentImportantInfo {
    id
    description
    banner
  }
  ... on ComponentContentSteps {
    id
    title
    stepItems {
      id
      description
      title
      steps {
        id
        content
      }
    }
  }
  ... on ComponentContentAccordion {
    id
    title
    items(pagination: {limit: -1}) {
      id
      content
      title
    }
  }
  ... on ComponentContentLinks {
    id
    title
    groups {
      id
      groupTitle
      links {
        ...NavigationMenuItemWithAssetFragment
      }
    }
  }
  ... on ComponentContentAdvantages {
    id
    title
    advantages {
      id
      title
      icon {
        ...UploadFileEntityResponseFragment
      }
    }
  }
  ... on ComponentContentMap {
    id
    title
    coordinates
    zoom
    link {
      ...NavigationMenuItemFragment
    }
  }
  ... on ComponentFeedbackFeedbackForm {
    id
    active
    feedbackTopics {
      data {
        id
        attributes {
          title
        }
      }
    }
    feedbackTopicRequired
    feedbackDocTypes {
      data {
        id
        attributes {
          title
          seriesRequired
          numberRequired
          hint
          hintPicture {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
    feedbackDocTypeRequired
    nameRequired
    surnameRequired
    patronymicRequired
    phoneRequired
    emailRequired
    emailRecipient
    title
    titleActive
    consentPDAPage {
      data {
        id
        attributes {
          title
        }
      }
    }
  }
  ... on ComponentMediaSelfHostedVideo {
    id
    title
    video {
      data {
        attributes {
          url
        }
      }
    }
    preview {
      data {
        attributes {
          url
        }
      }
    }
    __typename
  }
}
    ${NavigationMenuItemWithAssetFragmentFragmentDoc}
${UploadFileEntityResponseFragmentFragmentDoc}
${NavigationMenuItemFragmentFragmentDoc}`;
export const NewsPageFragmentFragmentDoc = gql`
    fragment NewsPageFragment on NewsPage {
  title
  slug
  metaDescription
  date
  imageLabel
  image {
    ...UploadFileEntityResponseFragment
  }
  content {
    ...DynamicContentFragment
  }
}
    ${UploadFileEntityResponseFragmentFragmentDoc}
${DynamicContentFragmentFragmentDoc}`;
export const NewsPageEntityFragmentFragmentDoc = gql`
    fragment NewsPageEntityFragment on NewsPageEntity {
  id
  attributes {
    ...NewsPageFragment
  }
}
    ${NewsPageFragmentFragmentDoc}`;
export const HolidayBannerDocument = gql`
    query HolidayBanner($locale: I18NLocaleCode!) {
  holidayBanner(locale: $locale) {
    data {
      id
      attributes {
        type
        title
        startsAt
        endsAt
        image {
          ...UploadFileEntityResponseFragment
        }
      }
    }
  }
}
    ${UploadFileEntityResponseFragmentFragmentDoc}`;

/**
 * __useHolidayBannerQuery__
 *
 * To run a query within a React component, call `useHolidayBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useHolidayBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHolidayBannerQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useHolidayBannerQuery(baseOptions: Apollo.QueryHookOptions<HolidayBannerQuery, HolidayBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HolidayBannerQuery, HolidayBannerQueryVariables>(HolidayBannerDocument, options);
      }
export function useHolidayBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HolidayBannerQuery, HolidayBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HolidayBannerQuery, HolidayBannerQueryVariables>(HolidayBannerDocument, options);
        }
export type HolidayBannerQueryHookResult = ReturnType<typeof useHolidayBannerQuery>;
export type HolidayBannerLazyQueryHookResult = ReturnType<typeof useHolidayBannerLazyQuery>;
export type HolidayBannerQueryResult = Apollo.QueryResult<HolidayBannerQuery, HolidayBannerQueryVariables>;
export const ContactPageDocument = gql`
    query ContactPage($slug: String!, $locale: I18NLocaleCode) {
  contactPage(slug: $slug, locale: $locale) {
    data {
      id
      attributes {
        metaDescription
        title
        slug
        addressLabel
        address
        workingHoursLabel
        workingHours
        phoneLabel
        phone
        zoom
        coordinates
        button {
          ...NavigationMenuItemFragment
        }
      }
    }
  }
}
    ${NavigationMenuItemFragmentFragmentDoc}`;

/**
 * __useContactPageQuery__
 *
 * To run a query within a React component, call `useContactPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useContactPageQuery(baseOptions: Apollo.QueryHookOptions<ContactPageQuery, ContactPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPageQuery, ContactPageQueryVariables>(ContactPageDocument, options);
      }
export function useContactPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPageQuery, ContactPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPageQuery, ContactPageQueryVariables>(ContactPageDocument, options);
        }
export type ContactPageQueryHookResult = ReturnType<typeof useContactPageQuery>;
export type ContactPageLazyQueryHookResult = ReturnType<typeof useContactPageLazyQuery>;
export type ContactPageQueryResult = Apollo.QueryResult<ContactPageQuery, ContactPageQueryVariables>;
export const DocumentPageDocument = gql`
    query DocumentPage($id: ID, $locale: I18NLocaleCode) {
  documentPages(locale: $locale, filters: {id: {eq: $id}}) {
    data {
      id
      attributes {
        title
        content
      }
    }
  }
}
    `;

/**
 * __useDocumentPageQuery__
 *
 * To run a query within a React component, call `useDocumentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useDocumentPageQuery(baseOptions?: Apollo.QueryHookOptions<DocumentPageQuery, DocumentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentPageQuery, DocumentPageQueryVariables>(DocumentPageDocument, options);
      }
export function useDocumentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentPageQuery, DocumentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentPageQuery, DocumentPageQueryVariables>(DocumentPageDocument, options);
        }
export type DocumentPageQueryHookResult = ReturnType<typeof useDocumentPageQuery>;
export type DocumentPageLazyQueryHookResult = ReturnType<typeof useDocumentPageLazyQuery>;
export type DocumentPageQueryResult = Apollo.QueryResult<DocumentPageQuery, DocumentPageQueryVariables>;
export const GalleryPageDocument = gql`
    query GalleryPage($locale: I18NLocaleCode) {
  galleryPage(locale: $locale) {
    data {
      id
      attributes {
        title
        categoryLabel
        slug
        metaDescription
      }
    }
  }
  mediaPages(locale: $locale, sort: ["order:asc"]) {
    data {
      id
      attributes {
        slug
        title
        preview {
          data {
            id
            attributes {
              formats
              url
            }
          }
        }
        gallery {
          __typename
          ... on ComponentMediaImage {
            id
          }
          ... on ComponentMediaRutube {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGalleryPageQuery__
 *
 * To run a query within a React component, call `useGalleryPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGalleryPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGalleryPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useGalleryPageQuery(baseOptions?: Apollo.QueryHookOptions<GalleryPageQuery, GalleryPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GalleryPageQuery, GalleryPageQueryVariables>(GalleryPageDocument, options);
      }
export function useGalleryPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GalleryPageQuery, GalleryPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GalleryPageQuery, GalleryPageQueryVariables>(GalleryPageDocument, options);
        }
export type GalleryPageQueryHookResult = ReturnType<typeof useGalleryPageQuery>;
export type GalleryPageLazyQueryHookResult = ReturnType<typeof useGalleryPageLazyQuery>;
export type GalleryPageQueryResult = Apollo.QueryResult<GalleryPageQuery, GalleryPageQueryVariables>;
export const MediaPageDocument = gql`
    query MediaPage($slug: String!, $locale: I18NLocaleCode) {
  mediaPage(slug: $slug, locale: $locale) {
    data {
      id
      attributes {
        title
        slug
        metaDescription
        date
        content {
          ...DynamicContentFragment
        }
        gallery {
          __typename
          ... on ComponentMediaImage {
            id
            title
            media {
              data {
                id
                attributes {
                  url
                  formats
                  width
                  height
                }
              }
            }
          }
          ... on ComponentMediaRutube {
            id
            title
            videoId
            preview {
              data {
                id
                attributes {
                  url
                  formats
                }
              }
            }
          }
          ... on ComponentMediaSelfHostedVideo {
            id
            title
            video {
              data {
                id
                attributes {
                  url
                  name
                }
              }
            }
            videoPreview: preview {
              data {
                id
                attributes {
                  url
                  formats
                  __typename
                }
              }
            }
          }
        }
      }
    }
  }
  galleryPage(locale: $locale) {
    data {
      id
      attributes {
        title
        slug
      }
    }
  }
}
    ${DynamicContentFragmentFragmentDoc}`;

/**
 * __useMediaPageQuery__
 *
 * To run a query within a React component, call `useMediaPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMediaPageQuery(baseOptions: Apollo.QueryHookOptions<MediaPageQuery, MediaPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaPageQuery, MediaPageQueryVariables>(MediaPageDocument, options);
      }
export function useMediaPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaPageQuery, MediaPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaPageQuery, MediaPageQueryVariables>(MediaPageDocument, options);
        }
export type MediaPageQueryHookResult = ReturnType<typeof useMediaPageQuery>;
export type MediaPageLazyQueryHookResult = ReturnType<typeof useMediaPageLazyQuery>;
export type MediaPageQueryResult = Apollo.QueryResult<MediaPageQuery, MediaPageQueryVariables>;
export const InfoPageDocument = gql`
    query InfoPage($slug: String!, $locale: I18NLocaleCode) {
  infoPage(slug: $slug, locale: $locale) {
    data {
      id
      attributes {
        title
        slug
        metaDescription
        content {
          ...DynamicContentFragment
        }
        documents {
          ...NavigationDocumentFragment
        }
        links {
          ...NavigationMenuItemFragment
        }
        buttons {
          ...NavigationMenuItemWithAssetFragment
        }
      }
    }
  }
}
    ${DynamicContentFragmentFragmentDoc}
${NavigationDocumentFragmentFragmentDoc}
${NavigationMenuItemFragmentFragmentDoc}
${NavigationMenuItemWithAssetFragmentFragmentDoc}`;

/**
 * __useInfoPageQuery__
 *
 * To run a query within a React component, call `useInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useInfoPageQuery(baseOptions: Apollo.QueryHookOptions<InfoPageQuery, InfoPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoPageQuery, InfoPageQueryVariables>(InfoPageDocument, options);
      }
export function useInfoPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoPageQuery, InfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoPageQuery, InfoPageQueryVariables>(InfoPageDocument, options);
        }
export type InfoPageQueryHookResult = ReturnType<typeof useInfoPageQuery>;
export type InfoPageLazyQueryHookResult = ReturnType<typeof useInfoPageLazyQuery>;
export type InfoPageQueryResult = Apollo.QueryResult<InfoPageQuery, InfoPageQueryVariables>;
export const MainPageDocument = gql`
    query MainPage($locale: I18NLocaleCode) {
  mainPage(locale: $locale) {
    data {
      id
      attributes {
        addressLabel
        metaDescription
        addressLink {
          ...NavigationLinkFragment
        }
        banner {
          id
          link {
            ...NavigationLinkFragment
          }
          text
          title
        }
        bannerAutoPlayInterval
        mainServices {
          id
          allServicesLink {
            ...NavigationMenuItemFragment
          }
          description
          title
          menu {
            ...NavigationMenuItemWithIconFragment
          }
        }
        additionalMenuTitle
        additionalMenu {
          ...NavigationMenuItemFragment
        }
        FAQTitle
        FAQ(pagination: {limit: -1}) {
          ...AccordionItemFragment
        }
        newsTitle
      }
    }
  }
  servicesMenu(locale: $locale) {
    data {
      id
      attributes {
        title
        menu {
          ...NavigationMenuItemFragment
        }
      }
    }
  }
  lastNews: newsPages(
    locale: $locale
    pagination: {limit: 9}
    sort: ["date:desc"]
  ) {
    data {
      ...NewsPageEntityFragment
    }
  }
}
    ${NavigationLinkFragmentFragmentDoc}
${NavigationMenuItemFragmentFragmentDoc}
${NavigationMenuItemWithIconFragmentFragmentDoc}
${AccordionItemFragmentFragmentDoc}
${NewsPageEntityFragmentFragmentDoc}`;

/**
 * __useMainPageQuery__
 *
 * To run a query within a React component, call `useMainPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMainPageQuery(baseOptions?: Apollo.QueryHookOptions<MainPageQuery, MainPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainPageQuery, MainPageQueryVariables>(MainPageDocument, options);
      }
export function useMainPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainPageQuery, MainPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainPageQuery, MainPageQueryVariables>(MainPageDocument, options);
        }
export type MainPageQueryHookResult = ReturnType<typeof useMainPageQuery>;
export type MainPageLazyQueryHookResult = ReturnType<typeof useMainPageLazyQuery>;
export type MainPageQueryResult = Apollo.QueryResult<MainPageQuery, MainPageQueryVariables>;
export const NewsListPageDocument = gql`
    query NewsListPage($locale: I18NLocaleCode) {
  newsListPage(locale: $locale) {
    data {
      id
      attributes {
        title
        categoryLabel
        slug
        mainNewsSlug
        metaDescription
        asideNews {
          id
          slug
        }
        pageSize
      }
    }
  }
}
    `;

/**
 * __useNewsListPageQuery__
 *
 * To run a query within a React component, call `useNewsListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useNewsListPageQuery(baseOptions?: Apollo.QueryHookOptions<NewsListPageQuery, NewsListPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListPageQuery, NewsListPageQueryVariables>(NewsListPageDocument, options);
      }
export function useNewsListPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListPageQuery, NewsListPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListPageQuery, NewsListPageQueryVariables>(NewsListPageDocument, options);
        }
export type NewsListPageQueryHookResult = ReturnType<typeof useNewsListPageQuery>;
export type NewsListPageLazyQueryHookResult = ReturnType<typeof useNewsListPageLazyQuery>;
export type NewsListPageQueryResult = Apollo.QueryResult<NewsListPageQuery, NewsListPageQueryVariables>;
export const NewsListContentDocument = gql`
    query NewsListContent($slug: String!, $locale: I18NLocaleCode, $asideNews: [String]!) {
  mainNews: newsPage(slug: $slug, locale: $locale) {
    data {
      id
      attributes {
        ...NewsPageFragment
        description
      }
    }
  }
  asideNews: newsPages(
    locale: $locale
    filters: {slug: {in: $asideNews}}
    sort: ["date:desc"]
  ) {
    data {
      ...NewsPageEntityFragment
    }
  }
}
    ${NewsPageFragmentFragmentDoc}
${NewsPageEntityFragmentFragmentDoc}`;

/**
 * __useNewsListContentQuery__
 *
 * To run a query within a React component, call `useNewsListContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListContentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *      asideNews: // value for 'asideNews'
 *   },
 * });
 */
export function useNewsListContentQuery(baseOptions: Apollo.QueryHookOptions<NewsListContentQuery, NewsListContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListContentQuery, NewsListContentQueryVariables>(NewsListContentDocument, options);
      }
export function useNewsListContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListContentQuery, NewsListContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListContentQuery, NewsListContentQueryVariables>(NewsListContentDocument, options);
        }
export type NewsListContentQueryHookResult = ReturnType<typeof useNewsListContentQuery>;
export type NewsListContentLazyQueryHookResult = ReturnType<typeof useNewsListContentLazyQuery>;
export type NewsListContentQueryResult = Apollo.QueryResult<NewsListContentQuery, NewsListContentQueryVariables>;
export const NewsListAllDocument = gql`
    query NewsListAll($excludeSlug: String!, $locale: I18NLocaleCode, $page: Int!, $pageSize: Int!) {
  allNews: newsPages(
    locale: $locale
    filters: {not: {slug: {eq: $excludeSlug}}}
    sort: ["date:desc"]
    pagination: {page: $page, pageSize: $pageSize}
  ) {
    meta {
      pagination {
        page
        pageCount
      }
    }
    data {
      id
      attributes {
        ...NewsPageFragment
        description
      }
    }
  }
}
    ${NewsPageFragmentFragmentDoc}`;

/**
 * __useNewsListAllQuery__
 *
 * To run a query within a React component, call `useNewsListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsListAllQuery({
 *   variables: {
 *      excludeSlug: // value for 'excludeSlug'
 *      locale: // value for 'locale'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useNewsListAllQuery(baseOptions: Apollo.QueryHookOptions<NewsListAllQuery, NewsListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsListAllQuery, NewsListAllQueryVariables>(NewsListAllDocument, options);
      }
export function useNewsListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsListAllQuery, NewsListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsListAllQuery, NewsListAllQueryVariables>(NewsListAllDocument, options);
        }
export type NewsListAllQueryHookResult = ReturnType<typeof useNewsListAllQuery>;
export type NewsListAllLazyQueryHookResult = ReturnType<typeof useNewsListAllLazyQuery>;
export type NewsListAllQueryResult = Apollo.QueryResult<NewsListAllQuery, NewsListAllQueryVariables>;
export const NewsPageDocument = gql`
    query NewsPage($slug: String!, $locale: I18NLocaleCode) {
  newsPage(slug: $slug, locale: $locale) {
    data {
      ...NewsPageEntityFragment
    }
  }
  lastNews: newsPages(
    locale: $locale
    filters: {not: {slug: {eq: $slug}}}
    pagination: {limit: 4}
    sort: ["date:desc"]
  ) {
    data {
      ...NewsPageEntityFragment
    }
  }
}
    ${NewsPageEntityFragmentFragmentDoc}`;

/**
 * __useNewsPageQuery__
 *
 * To run a query within a React component, call `useNewsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useNewsPageQuery(baseOptions: Apollo.QueryHookOptions<NewsPageQuery, NewsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsPageQuery, NewsPageQueryVariables>(NewsPageDocument, options);
      }
export function useNewsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsPageQuery, NewsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsPageQuery, NewsPageQueryVariables>(NewsPageDocument, options);
        }
export type NewsPageQueryHookResult = ReturnType<typeof useNewsPageQuery>;
export type NewsPageLazyQueryHookResult = ReturnType<typeof useNewsPageLazyQuery>;
export type NewsPageQueryResult = Apollo.QueryResult<NewsPageQuery, NewsPageQueryVariables>;
export const PolicyPageDocument = gql`
    query PolicyPage($locale: I18NLocaleCode) {
  privacyPolicyPage(locale: $locale) {
    data {
      id
      attributes {
        documentPage {
          data {
            attributes {
              title
              content
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePolicyPageQuery__
 *
 * To run a query within a React component, call `usePolicyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function usePolicyPageQuery(baseOptions?: Apollo.QueryHookOptions<PolicyPageQuery, PolicyPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyPageQuery, PolicyPageQueryVariables>(PolicyPageDocument, options);
      }
export function usePolicyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyPageQuery, PolicyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyPageQuery, PolicyPageQueryVariables>(PolicyPageDocument, options);
        }
export type PolicyPageQueryHookResult = ReturnType<typeof usePolicyPageQuery>;
export type PolicyPageLazyQueryHookResult = ReturnType<typeof usePolicyPageLazyQuery>;
export type PolicyPageQueryResult = Apollo.QueryResult<PolicyPageQuery, PolicyPageQueryVariables>;
export const SearchPageDocument = gql`
    query SearchPage($locale: I18NLocaleCode) {
  servicesPageCommon(locale: $locale) {
    data {
      id
      attributes {
        slugPayment
        slugInvoice
        slugInn
        slugStatus
        categoryLabel
      }
    }
  }
}
    `;

/**
 * __useSearchPageQuery__
 *
 * To run a query within a React component, call `useSearchPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useSearchPageQuery(baseOptions?: Apollo.QueryHookOptions<SearchPageQuery, SearchPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPageQuery, SearchPageQueryVariables>(SearchPageDocument, options);
      }
export function useSearchPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPageQuery, SearchPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPageQuery, SearchPageQueryVariables>(SearchPageDocument, options);
        }
export type SearchPageQueryHookResult = ReturnType<typeof useSearchPageQuery>;
export type SearchPageLazyQueryHookResult = ReturnType<typeof useSearchPageLazyQuery>;
export type SearchPageQueryResult = Apollo.QueryResult<SearchPageQuery, SearchPageQueryVariables>;
export const InnPageDocument = gql`
    query InnPage($locale: I18NLocaleCode) {
  serviceInnPage(locale: $locale) {
    data {
      id
      attributes {
        title
        metaDescription
        content {
          ...DynamicContentFragment
        }
        bottomContent {
          ...DynamicContentFragment
        }
      }
    }
  }
}
    ${DynamicContentFragmentFragmentDoc}`;

/**
 * __useInnPageQuery__
 *
 * To run a query within a React component, call `useInnPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInnPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInnPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useInnPageQuery(baseOptions?: Apollo.QueryHookOptions<InnPageQuery, InnPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InnPageQuery, InnPageQueryVariables>(InnPageDocument, options);
      }
export function useInnPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InnPageQuery, InnPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InnPageQuery, InnPageQueryVariables>(InnPageDocument, options);
        }
export type InnPageQueryHookResult = ReturnType<typeof useInnPageQuery>;
export type InnPageLazyQueryHookResult = ReturnType<typeof useInnPageLazyQuery>;
export type InnPageQueryResult = Apollo.QueryResult<InnPageQuery, InnPageQueryVariables>;
export const InvoicePageDocument = gql`
    query InvoicePage($locale: I18NLocaleCode) {
  serviceInvoicePage(locale: $locale) {
    data {
      id
      attributes {
        title
        metaDescription
        content {
          ...DynamicContentFragment
        }
        bottomContent {
          ...DynamicContentFragment
        }
      }
    }
  }
}
    ${DynamicContentFragmentFragmentDoc}`;

/**
 * __useInvoicePageQuery__
 *
 * To run a query within a React component, call `useInvoicePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useInvoicePageQuery(baseOptions?: Apollo.QueryHookOptions<InvoicePageQuery, InvoicePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePageQuery, InvoicePageQueryVariables>(InvoicePageDocument, options);
      }
export function useInvoicePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePageQuery, InvoicePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePageQuery, InvoicePageQueryVariables>(InvoicePageDocument, options);
        }
export type InvoicePageQueryHookResult = ReturnType<typeof useInvoicePageQuery>;
export type InvoicePageLazyQueryHookResult = ReturnType<typeof useInvoicePageLazyQuery>;
export type InvoicePageQueryResult = Apollo.QueryResult<InvoicePageQuery, InvoicePageQueryVariables>;
export const PaymentPageDocument = gql`
    query PaymentPage($locale: I18NLocaleCode) {
  servicePaymentPage(locale: $locale) {
    data {
      id
      attributes {
        title
        metaDescription
        content {
          ...DynamicContentFragment
        }
        bottomContent {
          ...DynamicContentFragment
        }
      }
    }
  }
}
    ${DynamicContentFragmentFragmentDoc}`;

/**
 * __usePaymentPageQuery__
 *
 * To run a query within a React component, call `usePaymentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function usePaymentPageQuery(baseOptions?: Apollo.QueryHookOptions<PaymentPageQuery, PaymentPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentPageQuery, PaymentPageQueryVariables>(PaymentPageDocument, options);
      }
export function usePaymentPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentPageQuery, PaymentPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentPageQuery, PaymentPageQueryVariables>(PaymentPageDocument, options);
        }
export type PaymentPageQueryHookResult = ReturnType<typeof usePaymentPageQuery>;
export type PaymentPageLazyQueryHookResult = ReturnType<typeof usePaymentPageLazyQuery>;
export type PaymentPageQueryResult = Apollo.QueryResult<PaymentPageQuery, PaymentPageQueryVariables>;
export const ServicePageDocument = gql`
    query ServicePage($locale: I18NLocaleCode) {
  servicesPageCommon(locale: $locale) {
    data {
      id
      attributes {
        slugPayment
        slugInvoice
        slugInn
        slugStatus
        categoryLabel
        linksLabel
        links {
          ...NavigationMenuItemFragment
        }
      }
    }
  }
  servicesMenu(locale: $locale) {
    data {
      id
      attributes {
        title
        menu {
          ...NavigationMenuItemFragment
        }
      }
    }
  }
}
    ${NavigationMenuItemFragmentFragmentDoc}`;

/**
 * __useServicePageQuery__
 *
 * To run a query within a React component, call `useServicePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useServicePageQuery(baseOptions?: Apollo.QueryHookOptions<ServicePageQuery, ServicePageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicePageQuery, ServicePageQueryVariables>(ServicePageDocument, options);
      }
export function useServicePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicePageQuery, ServicePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicePageQuery, ServicePageQueryVariables>(ServicePageDocument, options);
        }
export type ServicePageQueryHookResult = ReturnType<typeof useServicePageQuery>;
export type ServicePageLazyQueryHookResult = ReturnType<typeof useServicePageLazyQuery>;
export type ServicePageQueryResult = Apollo.QueryResult<ServicePageQuery, ServicePageQueryVariables>;
export const StatusPageDocument = gql`
    query StatusPage($locale: I18NLocaleCode) {
  serviceStatusPage(locale: $locale) {
    data {
      id
      attributes {
        title
        metaDescription
        content {
          ...DynamicContentFragment
        }
        bottomContent {
          ...DynamicContentFragment
        }
      }
    }
  }
}
    ${DynamicContentFragmentFragmentDoc}`;

/**
 * __useStatusPageQuery__
 *
 * To run a query within a React component, call `useStatusPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatusPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatusPageQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useStatusPageQuery(baseOptions?: Apollo.QueryHookOptions<StatusPageQuery, StatusPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StatusPageQuery, StatusPageQueryVariables>(StatusPageDocument, options);
      }
export function useStatusPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StatusPageQuery, StatusPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StatusPageQuery, StatusPageQueryVariables>(StatusPageDocument, options);
        }
export type StatusPageQueryHookResult = ReturnType<typeof useStatusPageQuery>;
export type StatusPageLazyQueryHookResult = ReturnType<typeof useStatusPageLazyQuery>;
export type StatusPageQueryResult = Apollo.QueryResult<StatusPageQuery, StatusPageQueryVariables>;
export const LayoutDocument = gql`
    query Layout($locale: I18NLocaleCode, $id: ID) {
  layout(id: $id) {
    data {
      id
      attributes {
        address
        copyright
        locale
        menuCategories {
          id
          title
          menuItems(pagination: {limit: -1}) {
            ...NavigationMenuItemFragment
          }
        }
        phone
        phoneDescription
        socialLinks {
          id
          title
          icon {
            ...UploadFileEntityResponseFragment
          }
          url
        }
        footerDocuments {
          data {
            id
            attributes {
              title
            }
          }
        }
        workingHours
        searchLabel
        searchQueries {
          id
          query
        }
      }
    }
  }
  mainPage(locale: $locale) {
    data {
      id
      attributes {
        metaDescription
      }
    }
  }
  galleryPage(locale: $locale) {
    data {
      id
      attributes {
        slug
      }
    }
  }
  newsListPage(locale: $locale) {
    data {
      id
      attributes {
        slug
      }
    }
  }
}
    ${NavigationMenuItemFragmentFragmentDoc}
${UploadFileEntityResponseFragmentFragmentDoc}`;

/**
 * __useLayoutQuery__
 *
 * To run a query within a React component, call `useLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLayoutQuery(baseOptions?: Apollo.QueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
      }
export function useLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LayoutQuery, LayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutQuery, LayoutQueryVariables>(LayoutDocument, options);
        }
export type LayoutQueryHookResult = ReturnType<typeof useLayoutQuery>;
export type LayoutLazyQueryHookResult = ReturnType<typeof useLayoutLazyQuery>;
export type LayoutQueryResult = Apollo.QueryResult<LayoutQuery, LayoutQueryVariables>;
export const LocaleDocument = gql`
    query Locale {
  layouts(locale: "all") {
    data {
      id
      attributes {
        locale
      }
    }
  }
}
    `;

/**
 * __useLocaleQuery__
 *
 * To run a query within a React component, call `useLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocaleQuery(baseOptions?: Apollo.QueryHookOptions<LocaleQuery, LocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocaleQuery, LocaleQueryVariables>(LocaleDocument, options);
      }
export function useLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocaleQuery, LocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocaleQuery, LocaleQueryVariables>(LocaleDocument, options);
        }
export type LocaleQueryHookResult = ReturnType<typeof useLocaleQuery>;
export type LocaleLazyQueryHookResult = ReturnType<typeof useLocaleLazyQuery>;
export type LocaleQueryResult = Apollo.QueryResult<LocaleQuery, LocaleQueryVariables>;